import { Particle } from "../particle";
import { colorLerp, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

/**
 * Green semi-transparent gas wisps billowing up from a deployed gas bomb while
 * it releases. Continuous generator (like bile smoke), tinted to match the Gas cell.
 */
export class GasLeakParticle extends Particle {
	static readonly emitIntervalMs = 120;

	constructor(originX: number, originY: number) {
		const ttl = randomBetween(800, 1200);

		const vx = randomBetween(-1.6, 1.6);
		const vy = randomBetween(-3.8, -1.4);

		const startSize = randomBetween(0.3, 0.4);
		const endSize = randomBetween(0.7, 1.0);

		const darkGas = {
			r: randomBetween(40, 65),
			g: randomBetween(120, 150),
			b: randomBetween(55, 80),
		};
		const lightGas = {
			r: randomBetween(95, 130),
			g: randomBetween(180, 215),
			b: randomBetween(95, 125),
		};

		const ox = originX + randomBetween(-0.4, 0.4);
		const oy = originY + randomBetween(-0.4, 0.4);

		super(ox, oy, {
			ttl,
			size: lerp(startSize, endSize),
			opacity: easeOut(0.9, 0.0),
			color: colorLerp(darkGas, lightGas),
			rotation: lerp(0, randomBetween(-1, 1)),
			position: linearMotion(vx, vy),
		});
	}
}
